import React from 'react';
import TextInput from '@atoms/TextInput/index';
import SelectPrefixes from '@molecules/SelectPrefixes';
import SelectSuffixes from '@molecules/SelectSuffixes';

const EditProfileFieldsName = () => (
    <>
        <SelectPrefixes />
        <TextInput label="First Name" name="firstName" type="text" disabled />
        <TextInput
            label="Informal First Name"
            name="informal"
            type="text"
            infoText="This is the name that will appear on your event badges."
        />
        <TextInput label="Last Name" name="lastName" type="text" disabled />
        <TextInput label="Designations" name="designations" type="text" disabled />
        <SelectSuffixes />
    </>
);

export default EditProfileFieldsName;
